import { Routes } from '@angular/router';
import { portalGuard } from './core/guards/portal.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/auth/components/login-redirect/login-redirect').then(m => m.LoginRedirectComponent)
  },
  {
    path: 'loginuser',
    loadComponent: () =>
      import('./modules/auth/components/login-user/login-user').then(m => m.LoginUser)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/error/error.routes').then(m => m.ERROR_ROUTES)
  },
  {
    path: 'cursos-programados',
    canActivate: [portalGuard],
    loadChildren: () =>
      import('./modules/catalogo-cursos/catalogo-cursos.routes').then(m => m.CATALOGO_CURSOS_ROUTES)
  },
  {
    path: 'design',
    canActivate: [portalGuard],
    loadChildren: () => import('./modules/design/design.routes').then(m => m.DESIGN_ROUTES)
  },
  {
    path: 'portal',
    canActivate: [portalGuard],
    loadComponent: () =>
      import('./modules/layout/components/main-component/main-component').then(m => m.MainComponent),
    children: [
      {
        path:'app-leacy',
        loadComponent:()=>import('./modules/layout/components/iframe-viewer/iframe-viewer').then(i=>i.IframeViewer)
      },
      {
        path: 'admin/usuarios',
        loadChildren: () =>
          import('./modules/admin-usuarios/admin-usuarios.routes').then(m => m.ADMIN_USUARIOS_ROUTES)
      },
      {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.routes').then(m => m.PROFILE_ROUTES)
      },{
        path: '',
        loadComponent:()=>import('./modules/dashboard/dashboard-page-component/dashboard-page-component').then(d=>d.DashboardPageComponent)
      },{
        path:'quick-access',
        loadChildren:()=> import('./modules/quick-access/quick-access.routes').then(q=>q.QUICK_ACCESS_ROUTES)
      }
    ]
  }
];
